<template>
  <div
    style="border-top-color: currentColor; border-left-color: currentColor"
    class="t-loader box-border w-6 h-6 block border-4 border-gray-400 text-gray-300 border-solid rounded-full animate-spin"
    :class="classes"
  />
</template>

<script setup lang="ts">
defineProps({
  classes: {
    type: String,
  },
})
</script>
